import { isValidDevMembershipToken } from "@/lib/helpers/is-valid-dev-membership-token";

/**
 * Validates the format of a membership token.
 *
 * A valid membership token must consist of four alphanumeric segments
 * (letters, numbers, or underscores) separated by dashes. For example:
 * "QUICK-BROWN-FOX-JUMP" or "word1-word2-word3-word4".
 *
 * @param {string} token - The membership token to validate.
 * @returns {boolean} True if the token matches the expected format; otherwise, false.
 */
export const isValidMembershipTokenFormat = (token: string): boolean => {
  const regex = /^\w+-\w+-\w+-\w+$/;
  return isValidDevMembershipToken(token) || regex.test(token);
}
